import axios from 'axios';

export function getErrorDataFromResponse(resp) {
  let result = {
    message: "",
    validation: {},
  }
  const respData = resp.data.error || resp.data;

  if (!respData) {
    result.message = "Ошибка выполнения запроса";
  }

  if (!!respData.message) {
    result.message = respData.message;
  }

  if (!!respData.validation) {
    result.validation = Object.assign({}, respData.validation)
  }

  return result;
};

export async function parseApiError(resp) {
  return Promise.reject(getErrorDataFromResponse(resp));
};

async function parseApiResponse(resp) {
  if (resp.data.error !== undefined) {
    return Promise.reject(resp.data.error);
  }
  return Promise.resolve(resp.data);
};

export async function executeApiGetRequest(apiPath, params) {
  return await axios({
    params,
    url: apiPath,
    method: 'GET',
  })
    .then(parseApiResponse)
    .catch(parseApiError);
};

export async function executeApiPostRequest(apiPath, data) {
  return await axios({
    data,
    url: apiPath,
    method: 'POST',
  })
    .then(parseApiResponse)
    .catch(parseApiError);
};

export default parseApiError;